import {Box, Divider, Flex, Stack, Text} from "@chakra-ui/react";
import {useIntl} from "next-intl";
import React from "react";

import useDraftShoppingCart from "../../hooks/useDraftShoppingCart";
import CheckoutModal from "../CheckoutModal/CheckoutModal";

function CartPriceAndCheckout({children}) {
    const intl = useIntl();
    const {draftShoppingCartSubTotal} = useDraftShoppingCart()
    // const taxesAndFees = Number((subTotal * 0.0875).toFixed(2))

    return (
        <Box>
            <Stack>
                <Flex justify='space-between' fontSize='md'>
                    <Text>Subtotal</Text>
                    <Text>{intl.formatNumber(draftShoppingCartSubTotal, {style: 'currency', currency: 'USD'})}</Text>
                </Flex>
            </Stack>
            <Flex direction='column'>
                <Box pt={4} pb={4}>
                    <Divider variant='dashed' opacity='1'/>
                </Box>
                <CheckoutModal/>
            </Flex>
        </Box>
    )
}

export default CartPriceAndCheckout